<template>
  <div id="map" style="height: 100vh; position: relative;">
    <!-- SVG Filter for Liquid Glass Effect -->
    <svg style="display: none">
      <filter
          id="glass-distortion"
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
      >
        <feTurbulence
            type="fractalNoise"
            baseFrequency="0.001 0.005"
            numOctaves="1"
            seed="17"
            result="turbulence"
        />
        <!-- Liked Seeds: 5, 14, 17 -->

        <feComponentTransfer in="turbulence" result="mapped">
          <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
          <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
          <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
        </feComponentTransfer>

        <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />

        <feSpecularLighting
            in="softMap"
            surfaceScale="5"
            specularConstant="1"
            specularExponent="100"
            lighting-color="white"
            result="specLight"
        >
          <fePointLight x="-200" y="-200" z="300" />
        </feSpecularLighting>

        <feComposite
            in="specLight"
            operator="arithmetic"
            k1="0"
            k2="1"
            k3="1"
            k4="0"
            result="litImage"
        />

        <feDisplacementMap
            in="SourceGraphic"
            in2="softMap"
            scale="200"
            xChannelSelector="R"
            yChannelSelector="G"
        />
      </filter>
    </svg>

    <!-- Route Directions Container -->
    <div class="directions-container">
      <div class="liquidGlass-effect"></div>
      <div class="liquidGlass-tint"></div>
      <div class="liquidGlass-shine"></div>
      <div class="directions-content">
        <div><img :src="iconDirections" alt="Back" class="icon"> Route Directions:</div>
        <ul>
          <br>
          <li v-for="(instruction, index) in navigationInstructions" :key="instruction.detail">
            <template v-if="index === 1">
              Then:
            </template>
            <h6>{{ instruction.detail }}</h6>
          </li>
        </ul>
      </div>
    </div>
    <div class="buttons-container">
      <button id="my-button-1" class="btn btn-sm btn-success" style="margin-bottom: 20px; border-radius: 50%; ">Back</button>
      <div class="switch-container"  style="transform: rotate(90deg);height: 90px;">
        <input type="checkbox" id="switch" v-model="navigationButton" @change="toggleNavigation" />
        <label for="switch"></label>
        <span class="nav-text">Map</span>
        <span class="map-text">Nav</span>
      </div>
    </div>
    <!-- Gateway Status Indicator -->
    <div class="gateway-status-container">
      <div
          class="gateway-status-circle"
          :class="{ 'online': gatewayOnline, 'offline': !gatewayOnline }"
          :title="`Gateway ${gatewayOnline ? 'Online' : 'Offline'}`"
      ></div>
    </div>
    <div class="next-meter-container">
      <button id="next-meter-btn" class="btn btn-sm btn-primary" @click="navigateToNextMeter" title="Next Meter">
        <span style="font-size: 20px;">→</span>
      </button>
    </div>
    <div class="next-meter-container">
      <button id="next-meter-btn" class="btn btn-sm btn-primary" @click="navigateToNextMeter" title="Next Meter">
        <span style="font-size: 20px;">→</span>
      </button>
    </div>


    <div class="speed-container " style="position: absolute; ">
      <h6> <img :src="iconSpeed" alt="speed" class="icon">: {{ currentSpeedKmH.toFixed(1) }}</h6>
    </div>
    <div class="readings-container showPanel" style="position: absolute; ">
      <div style="display: flex; align-items: center;">
        <div class="icon-sm-yes"></div>
        <span style="padding-left: 10px">to read: {{ nullReadingsCount }}</span>
      </div>
      <div style="display: flex; align-items: center; padding-top: 10px">
        <div class="icon-sm-no"></div>
        <span style="padding-left: 10px">total: {{ notNullReadingsCount }}</span>
      </div>
    </div>


    <div v-if="showPanel" ref="showPanel" class="showPanell collapsed"
         style="width: 60%; height: 100%; position: absolute; right: 0; top: 0; z-index: 9999; background: white; overflow: auto;">
      <div v-if="!showManualReadingForm" class="modal-content box">
        <div class="modal-header" style="margin: 20px">
          <button class="btn btn-dark" type="button" @click="togglePanel">Close panel</button>
        </div>
        <div class="modal-body" style="margin: 20px;">
          <div v-for="(meter, index) in selectedMeters" :key="meter.meterId" class="card mb-3 animate-row" :style="{ '--delay': index / 10 + 's' }">
            <div class="card-body row">
              <!-- Left Column -->
              <div class="col-md-8">
                <b><i>Radio: {{ meter.meterId }}</i></b><br>
                MPID: {{ meter.mpid }}<br>
                {{ meter.street }}, {{ meter.city }}<br>
                <img :src="getMeterStatus(meter).icon" alt="Status" style="width: 20px; height: 20px; vertical-align: middle;">
                <span>{{ getMeterStatus(meter).text }}</span>
              </div>

              <!-- Right Column -->
              <div class="col-md-4 d-flex align-items-center justify-content-center">
                <button class="btn btn-primary" @click="openMeterReadingForm(meter.meterId)">Enter Reading</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showManualReadingForm" class="modal-content box" style="display: block;"  >
        <div class="modal-content box">
          <div class="modal-header" style="margin: 20px">
            <button type="button" class="btn btn-dark" @click="closeManualReadingForm">
              <img src="../assets/backhand-left.png" alt="back" style="width: 20px; height: 20px"> Back
            </button>
          </div>
          <form @submit.prevent="submitManualReading" class="modal-body" style="margin: 20px;">
            <!-- Diagnostic Buttons -->
            <div class="row mb-3">
              <div class="col-md-6">
                <button v-for="diag in diagnostics.slice(0, 7)" :key="diag.id" type="button" class="btn margin btn-outline-secondary mb-2 " :class="{ 'active': selectedDiagnostics.includes(diag.id) }" @click="toggleDiagnostic(diag.id)">
                  {{ diag.label }}
                </button>
              </div>
              <div class="col-md-6">
                <button v-for="diag in diagnostics.slice(7)" :key="diag.id" type="button" class="btn margin btn-outline-secondary mb-2" :class="{ 'active': selectedDiagnostics.includes(diag.id) }" @click="toggleDiagnostic(diag.id)">
                  {{ diag.label }}
                </button>
              </div>
            </div>

            <!-- Reading Input -->
            <div class="mb-3">

              <input type="number" step="0.001" v-model="manualReading" class="form-control" id="readingInput" placeholder="Enter reading" required>
            </div>

            <!-- Form Footer -->
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary" style="margin-right: 20px">Submit</button>
              <button type="button" class="btn btn-secondary" @click="closeManualReadingForm">Cancel</button>
            </div>
          </form>
        </div>
      </div>

    </div>


    <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 111111">
      <div id="successToast" class="toast hide" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="3000">
        <div class="toast-header">
          <strong class="me-auto">Notification</strong>
          <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body">
          Reading submitted successfully.
        </div>
      </div>
    </div>


  </div>


</template>
<script>



import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import iconBack from '../assets/icon_back.png';
import iconDirections from '../assets/icon_directions.png';
import iconNav from '../assets/icon_nav.png';
import iconSpeed from '../assets/icon_speed.png';
import readedMeterIcon from '../assets/readedmeter.png';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import * as turf from '@turf/turf';
import axios from "axios";




export default {
  name: "CollectingReadings",
  components: {},

  data() {
    return {
      map: null,
      websocket: null,
      activeRouteID: null,
      nullReadingsCount: 0,
      notNullReadingsCount: 0,
      selectedMeters: [],
      showPanel: false,
      meterReadings: {},
      okHandImage: require('@/assets/ok-hand.png'),
      redCircleImage: require('@/assets/large-red-circle.png'),
      MyPositionIcon: require('@/assets/myposition.png'),
      navigationButton: false,
      animationFrameId: null,
      targetPosition: { lat: 0, lng: 0 },
      currentPosition: { lat: 0, lng: 0 },
      initialDataReceived: false,
      reconnectAttempts: 0,
      maxReconnectAttempts: 10,
      reconnectDelay: 1500,
      maxDelay: 60000,
      navigationInstructions: [],
      lastUpdateTimestamp: 0,
      updateThreshold: 5000,
      previusPosition: null,
      previusUpdateTime: null,
      currentSpeedKmH: 0,
      navigationInitialized: false,
      iconBack: iconBack,
      iconDirections: iconDirections,
      iconNav: iconNav,
      iconSpeed: iconSpeed,
      readedMeterIcon: readedMeterIcon,
      showManualReadingForm: false,
      diagnostics: [
        { id: 0, label: '(T) Tamper' },
        { id: 1, label: '(PUS) Failed to Communicate with device' },
        { id: 2, label:  'Back flow'},
        { id: 3, label:  'Leak allarm'},
        { id: 4, label:  'Poor RF'},
        { id: 5, label:  'Low battery'},
        { id: 6, label:  'Field programming'},
        { id: 7, label:  'System alert'},
        { id: 8, label:  'Temperature alert'},
        { id: 9, label:  'Tilt alert'},
        { id: 10, label:  '(Qmax)'},
        { id: 11, label:  'Burst'},
        { id: 12, label:  'Empty Pipe'},
        { id: 13, label:  'SDLB'},
        { id: 14, label: '(INVR) Invalid read from slave device' }
      ],
      selectedDiagnostics: [],
      selectedMeterId: null,
      manualReading: null,
      readingDate: null,
      allowReconnect: true,
      currentTargetMeterId: null,
      skipMeterIds: [],
      gatewayOnline: false,


    };
  },


  methods: {
    initializeMap() {
      this.map = new maplibregl.Map({
        container: 'map',
        style: 'https://api.maptiler.com/maps/streets/style.json?key=4DXCyU0jQcYTU9cFAGQu',
        center: [0, 0],
        zoom: 9
      });


      this.map.addControl(new maplibregl.NavigationControl(),);

      this.map.on('load', () => {

        this.map.addSource('readings', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: [],
          },
          cluster: true,
          clusterRadius: 50,
          clusterProperties: {
            // Keep track of the total and unread readings for each cluster
            'total': ['+', 1],
            'unread': ['+', ['case', ['==', ['get', 'unread'], 1], 1, 0]],
          },
        });

        // Add a layer for the clustered points
        this.map.addLayer({
          id: 'clusters',
          type: 'circle',
          source: 'readings',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': [
              'case',
              ['>', ['get', 'unread'], 0],
              '#fcba03', // Color for clusters with unread meters
              '#4fbd20'  // Color for clusters without unread meters
            ],
            'circle-radius': [
              'step',
              ['get', 'point_count'],
              30,
              100,
              30,
              750,
              40
            ],
            'circle-stroke-width': 1,
            'circle-stroke-color': '#fff',
            'circle-opacity': 0.8
          },
        });

        this.map.addLayer({
          id: 'cluster-count',
          type: 'symbol',
          source: 'readings',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count_abbreviated}/{unread}',
            'text-size': 12,
          },
        });

        this.map.addLayer({
          id: 'unclustered-point',
          type: 'circle',
          source: 'readings',
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': [
              'match',
              ['get', 'icon'],
              'positionMeterIcon', '#fcba03', // Yellow for meters with current_reading null
              'readedMeterIcon', '#4fbd20', // Green for meters with current_reading not null
              '#ccc' // Other (fallback color)
            ],
            'circle-radius': 20,
            'circle-stroke-width': 1,
            'circle-stroke-color': '#fff',
            'circle-opacity': 0.8
          }
        });


        this.map.on('click', 'unclustered-point', (e) => {
          const features = this.map.queryRenderedFeatures(e.point, { layers: ['unclustered-point'] });
          if (features.length) {
            this.selectedMeters = [features[0].properties];
            if (!this.showPanel) {
              this.showPanel = true;
              this.$nextTick(() => {
                this.togglePanel();
              });
            }
          }
        });

        this.map.on('click', 'clusters', async (e) => {
          const features = this.map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
          if (features.length) {
            const clusterId = features[0].properties.cluster_id;
            const source = this.map.getSource('readings');
            try {
              const leaves = await source.getClusterLeaves(clusterId, Infinity, 0);
              this.selectedMeters = leaves.map(leaf => leaf.properties);
              console.log('Selected meters:', this.selectedMeters);
              if (!this.showPanel) {
                this.showPanel = true;
                this.$nextTick(() => {
                  this.togglePanel();
                });
              }
            } catch (err) {
              console.error('Error getting cluster leaves:', err);
            }
          }
        });


        this.setupWebSocket();


      });

      //Button
      document.getElementById('my-button-1').addEventListener('click', () => {
        window.history.back();
      });


    },


    togglePanel(forceClose = false) {
      const panel = this.$refs.showPanel;
      const classes = panel.className.split(' ');
      const isCollapsed = classes.includes('collapsed');

      // Determine the action: toggle, force close, or nothing.
      if (forceClose || (this.showPanel && !isCollapsed)) {
        // Close the panel
        if (!classes.includes('collapsed')) classes.push('collapsed');
        this.showPanel = false;
        this.map.easeTo({
          padding: { right: 0 },
          duration: 1000
        });
      } else if (!this.showPanel || isCollapsed) {
        // Open the panel
        const index = classes.indexOf('collapsed');
        if (index !== -1) classes.splice(index, 1);
        this.showPanel = true;
        this.map.easeTo({
          padding: { right: panel.offsetWidth },
          duration: 1000
        });
      }

      panel.className = classes.join(' ');
    },

    setupWebSocket() {
      const routeName = this.$route.params.routeName;
      const token = localStorage.getItem('access_token');

      if (!token) {
        console.error('No authentication token available');
        return;
      }

      // Keep token in URL - this is the correct approach for WebSocket
      const params = new URLSearchParams({ routeName, token });
      if (this.activeRouteID) params.set('routeID', this.activeRouteID);
      const websocketUrl = `wss://metersuite.wtmeters.it/ws/omsroutes/active/name/ws?${params}`;

      console.log('Connecting to WebSocket:', websocketUrl);

      this.websocket = new WebSocket(websocketUrl);

      this.websocket.onopen = () => {
        console.log('WebSocket connection established');
        this.reconnectAttempts = 0;
      };

      this.websocket.onmessage = async (event) => {
        const message = JSON.parse(event.data);
        console.log('Received message:', message);

        switch(message.type) {
          case 'authenticated':
            console.log('WebSocket authenticated successfully:', message.message);
            break;

          case 'connected':
            console.log('WebSocket authenticated and connected:', message.message);
            break;

          case 'data':
          case 'update': {
            const data = message.data?.route;
            console.log('Route data received:', data);

            this.gatewayOnline = message.gateway_online === true;

            if (data) {
              this.activeRouteID = data._id || this.activeRouteID;

              if (data.meter_readings) {
                this.meterReadings = data.meter_readings;
                this.notNullReadingsCount = 0;
                this.nullReadingsCount = 0;

                const entries = Object.entries(data.meter_readings);
                let features = entries.map(([meterId, meterData]) => {
                  const hasReading = meterData.readings?.current_reading != null;
                  hasReading ? this.notNullReadingsCount++ : this.nullReadingsCount++;

                  return {
                    type: 'Feature',
                    properties: {
                      ...meterData,
                      meterId: meterId,
                      icon: hasReading ? 'readedMeterIcon' : 'positionMeterIcon',
                      unread: hasReading ? 0 : 1,
                    },
                    geometry: {
                      type: 'Point',
                      coordinates: [parseFloat(meterData.lon), parseFloat(meterData.lat)]
                    }
                  };
                });

                this.map.getSource('readings').setData({
                  type: 'FeatureCollection',
                  features: features,
                });

                if (!this.initialDataReceived && features.length > 0) {
                  const bounds = new maplibregl.LngLatBounds();
                  features.forEach(feature => bounds.extend(feature.geometry.coordinates));
                  this.map.fitBounds(bounds, {padding: 150});
                  this.initialDataReceived = true;

                  // Only navigate to nearest meter on initial load
                  await this.navigateNextUnreadMeter();
                }
                // On subsequent updates (reconnection), don't reset navigation
                // The skip list and current target are preserved
              }
            }
            break;
          }

          case 'error':
            console.error('WebSocket error message:', message.error);
            if (message.error?.code === 'AUTH-001' || message.error?.message?.includes('Authentication')) {
              console.error('Authentication failed, redirecting to login');
              this.$router.push('/login');
              return;
            }
            break;

          case 'pong':
            console.log('Connection alive');
            break;

          default:
            console.log('Unknown message type:', message.type);
        }
      };

      this.websocket.onclose = (event) => {
        console.log('WebSocket is closed. Reconnect will be attempted.', event.reason);
        // Set gateway offline when connection closes
        this.gatewayOnline = false;

        if (this.reconnectAttempts < this.maxReconnectAttempts && this.allowReconnect) {
          setTimeout(() => {
            this.setupWebSocket();
          }, Math.min(this.reconnectDelay * Math.pow(2, this.reconnectAttempts), this.maxDelay));
          this.reconnectAttempts++;
        } else {
          console.log('Reconnection attempts stopped.');
        }
      };

      this.websocket.onerror = (err) => {
        console.error('WebSocket encountered error:', err);
        this.websocket.close(); // This triggers the onclose event
      };

      // Set up ping interval to keep connection alive
      this.pingInterval = setInterval(() => {
        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
          this.websocket.send(JSON.stringify({ type: 'ping' }));
        }
      }, 2000); // Ping every 2 seconds
    },


    async navigateNextUnreadMeter() {
      if (!navigator.geolocation) {
        console.error("Geolocation is not supported by this browser.");
        return;
      }

      // Reset skip list when navigating to nearest (initial load)
      this.skipMeterIds = [];
      this.currentTargetMeterId = null;

      navigator.geolocation.getCurrentPosition(
          async (position) => {
            const userPosition = { lat: position.coords.latitude, lng: position.coords.longitude };
            await this.findAndDrawRouteToNearestMeter(userPosition);
          },
          error => console.error('Error getting user position:', error),
          { enableHighAccuracy: true, timeout: 5000 }
      );
    },
    async navigateToNextMeter() {
      if (!navigator.geolocation) {
        console.error("Geolocation is not supported by this browser.");
        return;
      }

      navigator.geolocation.getCurrentPosition(
          async (position) => {
            const userPosition = { lat: position.coords.latitude, lng: position.coords.longitude };

            // Add current target to skip list
            if (this.currentTargetMeterId) {
              if (!this.skipMeterIds.includes(this.currentTargetMeterId)) {
                this.skipMeterIds.push(this.currentTargetMeterId);
              }
            }

            // Find the next unread meter (excluding skipped ones)
            const nextMeter = this.findNextUnreadMeter(userPosition);

            if (!nextMeter) {
              console.log('No more unread meters available');
              this.skipMeterIds = [];
              this.currentTargetMeterId = null;

              const bootstrap = await import('../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js');
              const toastEl = document.getElementById('successToast');
              const toastBody = toastEl.querySelector('.toast-body');
              toastBody.textContent = 'No more unread meters available';
              const toast = new bootstrap.Toast(toastEl, {
                autohide: true,
                delay: 3000
              });
              toast.show();
              return;
            }

            // Store the new target meter ID
            this.currentTargetMeterId = this.getMeterId(nextMeter);

            await this.findAndDrawRouteToSpecificMeter(userPosition, nextMeter);

            if (this.navigationButton) {
              this.updateOrCreateUserPositionMarker(userPosition);
            }
          },
          error => console.error('Error getting user position:', error),
          { enableHighAccuracy: true, timeout: 5000 }
      );
    },
    async findAndDrawRouteToSpecificMeter(userPosition, meter) {
      if (!meter || !meter.lon || !meter.lat) {
        console.error('Invalid meter coordinates');
        return;
      }

      const meterPosition = { lat: parseFloat(meter.lat), lng: parseFloat(meter.lon) };
      const osrmRouteUrl = `https://metersuite.wtmeters.it/routing/route/v1/driving/${userPosition.lng},${userPosition.lat};${meterPosition.lng},${meterPosition.lat}?overview=full&geometries=geojson&steps=true`;

      try {
        const response = await fetch(osrmRouteUrl);
        const data = await response.json();
        if (data && data.routes && data.routes.length) {
          this.currentRoute = data.routes[0];
          this.updateRouteOnMap(data.routes[0]);
          this.processNavigationInstructions(data.routes[0]);

          // Only update map view if NOT in navigation mode
          if (!this.navigationButton) {
            const coordinates = data.routes[0].geometry.coordinates;
            const bounds = new maplibregl.LngLatBounds();
            coordinates.forEach(coord => bounds.extend(coord));
            this.map.fitBounds(bounds, { padding: 50 });
          }
          // If in navigation mode, the camera will be handled by calculateNavigationAndStart
        }
      } catch (error) {
        console.error('Failed to draw route to specific meter', error);
      }
    },
    findNextUnreadMeter(userPosition) {
      if (Object.keys(this.meterReadings).length === 0) {
        console.log('No meter readings available.');
        return null;
      }

      let unreadMeters = [];

      Object.entries(this.meterReadings).forEach(([meterId, meter]) => {
        if (meter.readings.current_reading !== null) return;
        if (this.skipMeterIds.includes(meterId)) {
          console.log(`Skipping meter ${meterId}`);
          return;
        }

        const meterPosition = {
          lat: parseFloat(meter.lat),
          lng: parseFloat(meter.lon)
        };

        const distance = this.getDistanceFromLatLonInKm(
            userPosition.lat,
            userPosition.lng,
            meterPosition.lat,
            meterPosition.lng
        );

        unreadMeters.push({ meter, distance, meterId });
      });

      if (unreadMeters.length === 0) {
        return null;
      }

      unreadMeters.sort((a, b) => a.distance - b.distance);

      return unreadMeters[0].meter;
    },
    getMeterId(meter) {
      return meter.meterId || meter.meter_id || Object.keys(this.meterReadings).find(
          key => this.meterReadings[key] === meter
      );
    },

    handleClickOutside(event) {
      const mapElement = document.getElementById('map');
      const panelElement = this.$refs.showPanel;

      // Check if the click is outside the map and panel
      if (mapElement && panelElement && !mapElement.contains(event.target) && !panelElement.contains(event.target)) {
        this.showPanel = false;
      }
    },

    async toggleNavigation() {
      if (!navigator.geolocation) {
        console.error("Geolocation is not supported by this browser.");
        return;
      }

      try {
        const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
        if (permissionStatus.state === "granted" || permissionStatus.state === "prompt") {
          if (!this.navigationInitialized) {
            // Initialize navigation for the first time
            this.initializeNavigation();
            this.navigationInitialized = true;
            console.log('Navigation mode initialized and enabled for the first time.');
            this.initializeUserPositionAndRoute();
          } else {
            console.log(this.navigationButton ? 'Navigation mode enabled.' : 'Navigation mode disabled.');
            // Toggle navigation based on the current state of `navigationButton`
            if (this.navigationButton) {
              this.initializeUserPositionAndRoute(); // Or any other logic to "enable" navigation
            } else {
              this.disableNavigation(); // Logic to "disable" navigation
            }
          }
        } else {
          console.log('Location permission is denied');
        }
      } catch (error) {
        console.error("Error while trying to get permissions:", error);
      }
    },




    disableNavigation() {
      // Remove any navigation-specific overlays, such as the route line or navigation arrows
      if (this.map.getLayer('route')) {
        this.map.removeLayer('route');
        this.map.removeLayer('route-outer');
      }
      if (this.map.getSource('route')) {
        this.map.removeSource('route');
      }

      // Reset navigation mode flags and UI elements if needed
      this.navigationButton = false;
      this.navigationInitialized = false;

      // Stop watching the user's position
      this.stopPositionUpdates(); // This is where you clear the watch ID

      // Clear instructions and reset the currentIndex

      this.navigationInstructions = []; // Assuming this is what you use to display instructions in the UI
      this.currentIndex = 0;

      // Refresh markers to show all on the map and fit them within the view
      this.refreshMarkersAndView();

      console.log('Navigation mode has been disabled. Map is now in default state with all markers visible.');
    },


    refreshMarkersAndView() {
      // Assuming `this.meterReadings` holds the latest data
      const features = this.compileFeaturesFromMeterReadings(this.meterReadings);

      // Update the source with the latest features
      if (this.map.getSource('readings')) {
        this.map.getSource('readings').setData({
          type: 'FeatureCollection',
          features: features,
        });
      }

      // Fit the map bounds to include all markers if there are any
      if (features.length > 0) {
        const bounds = new maplibregl.LngLatBounds();
        features.forEach(feature => bounds.extend(feature.geometry.coordinates));
        this.map.fitBounds(bounds, { padding: 20, pitch: 0 });
      }
    },

    compileFeaturesFromMeterReadings(meterReadings) {
      return Object.entries(meterReadings).map(([, meterData]) => ({
        type: 'Feature',
        properties: {
          icon: meterData.readings.current_reading === null ? 'positionMeterIcon' : 'readedMeterIcon',
          unread: meterData.readings.current_reading === null ? 1 : 0,
          ...meterData,
        },
        geometry: {
          type: 'Point',
          coordinates: [parseFloat(meterData.lon), parseFloat(meterData.lat)]

        }
      }));
    },

    handlePermissionChange(permissionStatus) {
      if (permissionStatus.state === "granted") {
        if (!this.navigationInitialized) {
          this.initializeNavigation(); // Initializes navigation without needing a page refresh
        }
      } else if (permissionStatus.state === "prompt") {
        // Handle prompt state if necessary
      } else {
        console.log('Location permission is denied');
      }
    },


    initializeNavigation() {
      // Method to initialize navigation (called once upon first permission grant)
      this.navigationInitialized = true;
      this.navigationButton = true; // Considered as enabling navigation
      console.log('Navigation mode initialized and enabled.');
      this.initializeUserPositionAndRoute(); // Initialize user position and start route-related functionalities
    },


    initializeUserPositionAndRoute() {
      if (!navigator.geolocation) {
        console.error("Geolocation is not supported by this browser.");
        return;
      }
      navigator.geolocation.getCurrentPosition(
          async (position) => {
            const userPosition = { lat: position.coords.latitude, lng: position.coords.longitude };
            this.updateOrCreateUserPositionMarker(userPosition);
            await this.findAndDrawRouteToNearestMeter(userPosition);
            await this.startWatchingUserPosition();
          },
          error => console.error('Error getting user position:', error),
          { enableHighAccuracy: true, timeout: 500 }
      );
    },

    updateOrCreateUserPositionMarker(userPosition) {
      if (!this.userPositionMarker) {
        // Create the marker for the first time
        const el = document.createElement('div');
        el.className = 'marker';
        el.style.backgroundImage = `url(${this.MyPositionIcon})`;
        el.style.width = '50px';
        el.style.height = '50px';
        el.style.backgroundSize = '100%';
        el.style.backgroundPosition = 'center';
        el.style.borderRadius = '50%';
        this.userPositionMarker = new maplibregl.Marker({ element: el, rotationAlignment: 'map' })
            .setLngLat([userPosition.lng, userPosition.lat])
            .addTo(this.map);
      } else {
        // Marker already exists; optional updates could be handled here
      }
    },
    async startWatchingUserPosition() {
      console.log('startWatchingUserPosition started');
      if (!this.watchId) {
        this.watchId = navigator.geolocation.watchPosition(async (position) => { // Mark this callback as async
          const newPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };


          // Now that the callback is async, you can use await here
          await this.calculateNavigationAndStart(newPosition);
        }, error => {
          console.error('Error watching user position:', error);
        }, {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: 10000,
        });
      }
    },




    async findAndDrawRouteToNearestMeter(userPosition) {
      // Check if navigation is enabled before proceeding
      if (!this.navigationButton) {
        console.log('Navigation is disabled. Aborting route drawing.');
        return;
      }

      const nearestMeter = this.findNearestMeter(userPosition);
      if (!nearestMeter || !nearestMeter.lon || !nearestMeter.lat) {
        console.error('No nearest meter found or invalid coordinates');
        return;
      }

      const nearestMeterPosition = { lat: parseFloat(nearestMeter.lat), lng: parseFloat(nearestMeter.lon) };
      const osrmRouteUrl = `https://metersuite.wtmeters.it/routing/route/v1/driving/${userPosition.lng},${userPosition.lat};${nearestMeterPosition.lng},${nearestMeterPosition.lat}?overview=full&geometries=geojson&steps=true`;


      try {
        const response = await fetch(osrmRouteUrl);
        const data = await response.json();
        if (data && data.routes && data.routes.length) {
          this.currentRoute = data.routes[0];
          this.updateRouteOnMap(data.routes[0]);
          this.processNavigationInstructions(data.routes[0]);
        }
      } catch (error) {
        console.error('Failed to draw route', error);
      }
    },



    processNavigationInstructions(route) {
      if (!route || !route.legs) {
        console.error('Invalid route data');
        return;
      }

      const steps = route.legs.flatMap(leg => leg.steps);
      this.allNavigationInstructions = steps.map((step, index) => {
        const { distance, duration, name } = step;
        let instruction = step.maneuver.instruction; // This might be undefined for some steps

        if (!instruction) {
          switch(step.maneuver.type) {
            case 'depart':
              instruction = 'Continue'; // Default instruction for 'depart'
              break;
            case 'turn':
              instruction = `Turn ${step.maneuver.modifier}`; // e.g., "Turn right"
              break;
            case 'new name':
              instruction = `Continue onto ${step.name}`; // When the road name changes
              break;
            case 'arrive':
              instruction = 'You have arrived at your destination'; // When the user arrives
              break;
            case 'roundabout':
            case 'rotary':
              instruction = `Enter the roundabout`; // For roundabouts, additional logic might be needed for exit number
              break;
            case 'merge':
              instruction = `Merge ${step.maneuver.modifier}`; // e.g., "Merge left"
              break;
            case 'on ramp':
              instruction = `Take the ramp on the ${step.maneuver.modifier}`; // e.g., "Take the ramp on the right"
              break;
            case 'off ramp':
              instruction = `Take the exit on the ${step.maneuver.modifier}`; // e.g., "Take the exit on the right"
              break;
            case 'end of road':
              instruction = `Turn ${step.maneuver.modifier} at the end of the road`; // e.g., "Turn right at the end of the road"
              break;
            case 'continue':
              instruction = `Continue on ${step.name}`; // For simply continuing on the same road
              break;
            case 'fork':
              instruction = `Keep ${step.maneuver.modifier} at the fork`; // e.g., "Keep left at the fork"
              break;

            default:
              instruction = `Continue`; // A generic fallback for any unhandled maneuver types
          }
        }


        // Construct the detail string with a fallback for name in case it's not provided
        const detail = `${instruction} ${name ? 'onto ' + name : ''} for ${distance.toFixed(0)} meters.`;

        return {
          index,
          instruction,
          detail,
          distance,
          duration: duration.toFixed(0),
          coordinates: step.maneuver.location, // Store the coordinates for each step
        };
      });
    },


    updateCurrentInstruction(userPosition) {
      if (!this.allNavigationInstructions.length) return;

      const userPoint = turf.point([userPosition.lng, userPosition.lat]);
      let nearestStepIndex = null;
      let nearestDistance = Infinity;

      // Find the nearest step to the user by reducing the search space
      // Assuming steps are in order, we can limit the search to a reasonable range around the user
      const currentIndex = this.currentIndex || 0; // Start from the last known index, or 0 if not set
      const searchRange = 5; // Define a search range to limit the number of comparisons

      // Calculate start and end indexes to limit the search space
      const startIndex = Math.max(currentIndex - searchRange, 0);
      const endIndex = Math.min(currentIndex + searchRange, this.allNavigationInstructions.length - 1);

      for (let i = startIndex; i <= endIndex; i++) {
        const step = this.allNavigationInstructions[i];
        const stepPoint = turf.point(step.coordinates);
        const distance = turf.distance(userPoint, stepPoint, { units: 'meters' });

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestStepIndex = i;
        }
      }

      // Update currentIndex for the next update cycle
      this.currentIndex = nearestStepIndex;

      // Update instructions for UI
      if (nearestStepIndex !== null) {
        const currentInstruction = this.allNavigationInstructions[nearestStepIndex];
        const instructionsToDisplay = [currentInstruction];

        // Optionally, add the next instruction if it's a significant change in direction
        const hasNextStep = nearestStepIndex + 1 < this.allNavigationInstructions.length;
        if (hasNextStep && nearestDistance > 10) { // Adjust threshold as needed
          instructionsToDisplay.push(this.allNavigationInstructions[nearestStepIndex + 1]);
        }

        this.navigationInstructions = instructionsToDisplay;
      }
    },



    findNearestMeter(userPosition) {
      if (Object.keys(this.meterReadings).length === 0) {
        console.log('No meter readings available.');
        return null;
      }

      let nearestMeter = null;
      let nearestDistance = Infinity;

      // Iterate over each meter in meterReadings
      Object.values(this.meterReadings).forEach((meter) => {
        // Check if current_reading is null, indicating no reading has been taken
        if (meter.readings.current_reading !== null) return;

        // Parse meter position and calculate the distance to the user's position
        const meterPosition = {
          lat: parseFloat(meter.lat),  // ✅ Latitude to lat
          lng: parseFloat(meter.lon)   // ✅ Longitude to lng
        };

        const distance = this.getDistanceFromLatLonInKm(userPosition.lat, userPosition.lng, meterPosition.lat, meterPosition.lng);
        console.log('Distance:', distance); // Log distance

        // Update nearest meter if this meter is closer than any previously checked
        if (distance < nearestDistance) {
          nearestMeter = meter;
          nearestDistance = distance;
        }
      });

      return nearestMeter;
    },



    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the earth in km
      const dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
      const dLon = this.deg2rad(lon2 - lon1);
      const a =
          Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon/2) * Math.sin(dLon/2)
      ;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      const distance = R * c; // Distance in km
      return distance;
    },

    deg2rad(deg) {
      return deg * (Math.PI/180);
    },



    async calculateNavigationAndStart (userPosition) {
      console.log('calculateNavigationAndStart started');
      if (!this.currentRoute) return;

      const routeLine = turf.lineString(this.currentRoute.geometry.coordinates);
      const userPoint = turf.point([userPosition.lng, userPosition.lat]);
      const snapped = turf.nearestPointOnLine(routeLine, userPoint, {units: 'meters'});

      this.userPositionMarker.setLngLat(snapped.geometry.coordinates);
      const distance = turf.distance(userPoint, snapped, {units: 'meters'});

      if (distance > 10) {
        console.log('Deviation detected. Recalculating route...');
        await this.findAndDrawRouteToNearestMeter(userPosition);
      } else {
        // Calculate speed in km/h before potentially moving the marker smoothly
        const speedKmPerHour = this.calculateSpeedKmPerHour(userPosition, this.previousPosition, this.previousTimestamp);
        console.log(`Current speed: ${speedKmPerHour.toFixed(2)} km/h`);


        // Use the speed for logic, such as adjusting animation speed
        await this.smoothlyMoveMarker(userPosition, speedKmPerHour); // Pass the speed to smoothlyMoveMarker if needed
      }

      console.log('Nearest point on route to user:', snapped.geometry.coordinates);
      await this.updateBearingAfterAnimation(snapped);
      this.updateCurrentInstruction(userPosition);
    },

    calculateSpeedKmPerHour(newPosition, oldPosition, oldTimestamp) {
      const currentTime = Date.now(); // Current time in milliseconds

      if (!oldPosition || !oldTimestamp) {
        console.log("Initial position update, speed unknown.");
        this.previousPosition = newPosition;
        this.previousTimestamp = currentTime;
        return 0; // Initial speed is unknown or zero.
      }

      // Calculate the time elapsed in hours
      const timeElapsedHours = (currentTime - oldTimestamp) / (1000 * 60 * 60);
      console.log(`Time elapsed in hours: ${timeElapsedHours}`);

      // Calculate the distance between the old position and the new position in kilometers
      const distanceKm = turf.distance(
          turf.point([oldPosition.lng, oldPosition.lat]),
          turf.point([newPosition.lng, newPosition.lat]),
          { units: 'kilometers' }
      );
      console.log(`Distance traveled in km: ${distanceKm}`);

      // Calculate the speed in kilometers per hour
      const speedKmPerHour = distanceKm / timeElapsedHours;
      console.log(`Calculated speed: ${speedKmPerHour} km/h`);

      // Only update the old position and timestamp after speed calculation
      this.previousPosition = newPosition;
      this.previousTimestamp = currentTime;

      // Ensure this part of the state is updated for the component or DOM update
      this.currentSpeedKmH = speedKmPerHour;

      return speedKmPerHour;
    },




    async smoothlyMoveMarker(userPosition, speedKmPerHour) {
      console.log('User position:', userPosition);
      console.log('Speed (km/h):', speedKmPerHour);

      if (!this.currentRoute) {
        console.error("No current route available for smoothly moving marker.");
        return;
      }

      if (speedKmPerHour <= 1) { // Assuming a speed threshold of 1 km/h
        console.log("Driver is not moving significantly.");
        return;
      }

      const currentPosition = turf.point([userPosition.lng, userPosition.lat]);
      console.log('Current position:', currentPosition);

      const snapped = turf.nearestPointOnLine(turf.lineString(this.currentRoute.geometry.coordinates), currentPosition);
      console.log('Snapped position:', snapped);

      if (snapped.properties.index < this.currentRoute.geometry.coordinates.length - 1) {
        // Calculate bearing to the next point in the route
        const nextPointCoordinates = this.currentRoute.geometry.coordinates[snapped.properties.index + 1];
        console.log('Next point coordinates:', nextPointCoordinates);

        const bearing = this.calculateBearingForPath(snapped.geometry.coordinates[1], snapped.geometry.coordinates[0], nextPointCoordinates[1], nextPointCoordinates[0]);
        console.log('Bearing:', bearing);

        // Predict the next position based on current speed and bearing
        const predictedNextPosition = this.predictNextPosition(snapped, bearing, speedKmPerHour);

        // Snap the predicted position to the route to ensure it's valid
        const snappedNextPosition = turf.nearestPointOnLine(turf.lineString(this.currentRoute.geometry.coordinates), turf.point(predictedNextPosition)).geometry.coordinates;
        console.log('Snapped next position:', snappedNextPosition);

        // Animate the marker to the snapped next position
        this.transitionMarker(snappedNextPosition, speedKmPerHour);
      } else {
        console.log("End of route or unable to move further along the path.");
      }
    },


    transitionMarker(targetCoordinates, speedKmPerHour) {
      const currentLngLat = this.userPositionMarker.getLngLat();
      const speedMPerS = speedKmPerHour * 1000 / 3600;

      // Calculate the distance to target in meters for animation duration
      const distanceMeters = turf.distance(
          turf.point([currentLngLat.lng, currentLngLat.lat]),
          turf.point(targetCoordinates),
          { units: 'meters' }
      );
      const duration = Math.max((distanceMeters / speedMPerS) * 1000, 500); // Ensure minimum duration

      let start = performance.now();
      const animate = (now) => {
        let elapsedTime = now - start;
        let progress = Math.min(elapsedTime / duration, 1);

        let lng = currentLngLat.lng + (targetCoordinates[0] - currentLngLat.lng) * progress;
        let lat = currentLngLat.lat + (targetCoordinates[1] - currentLngLat.lat) * progress;

        this.userPositionMarker.setLngLat([lng, lat]);

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    },

    calculateBearingForPath(startLat, startLng, destLat, destLng) {
      const startCoord = [startLng, startLat];
      const destCoord = [destLng, destLat];
      return turf.bearing(turf.point(startCoord), turf.point(destCoord));
    },

    predictNextPosition(currentPosition, bearing, speedKmPerHour) {
      // Convert speed from km/h to meters per second
      const speedMPerS = speedKmPerHour / 3.6;
      // Assuming prediction for one second into the future
      const distance = speedMPerS * 1; // distance = speed * time

      // Calculate next position
      return turf.destination(currentPosition, distance, bearing, { units: 'meters' }).geometry.coordinates;
    },



    async updateBearingAfterAnimation(snapped) {
      // Dynamically find the next point based on user's progression
      const { nearestPointIndex, nextPointIndex } = this.findNearestAndNextPointIndices(snapped);

      if (nearestPointIndex !== undefined && nextPointIndex !== undefined && this.currentRoute.geometry.coordinates.length > nextPointIndex) {
        const nearestPointCoordinates = this.currentRoute.geometry.coordinates[nearestPointIndex];
        const nextPointCoordinates = this.currentRoute.geometry.coordinates[nextPointIndex];

        // Calculate bearing from nearest point to next point
        const bearing = turf.bearing(turf.point(nearestPointCoordinates), turf.point(nextPointCoordinates));

        // Project a new point 10 meters ahead of the nearest point along the bearing
        const projectedPoint = turf.destination(turf.point(nearestPointCoordinates), 0.05, bearing, { units: 'kilometers' });

        // Prepare the map transition options
        const mapTransitionOptions = {
          center: projectedPoint.geometry.coordinates,
          bearing: bearing,
          zoom: 18,
          pitch: 60,
          duration: 1000, // Duration of the transition in milliseconds
          essential: true
        };

        // Smoothly transition the map to the new bearing and projected point
        if (this.map.getLayer('route')) { // Ensure the route layer exists
          this.map.easeTo(mapTransitionOptions);
        } else {
          // If the route layer doesn't exist, fly directly without easing
          this.map.flyTo(mapTransitionOptions);
        }
      }
    },



    findNearestAndNextPointIndices(snapped) {
      const routeCoords = this.currentRoute.geometry.coordinates;
      let nearestPointIndex = -1;
      let smallestDistance = Infinity;

      // Calculate the distance to each point on the route to find the actual nearest point
      routeCoords.forEach((coord, index) => {
        const distance = turf.distance(turf.point(coord), turf.point(snapped.geometry.coordinates), { units: 'meters' });
        if (distance < smallestDistance) {
          smallestDistance = distance;
          nearestPointIndex = index;
        }
      });

      if (nearestPointIndex === -1) {
        console.error("Couldn't find a nearest point index.");
        return { nearestPointIndex: undefined, nextPointIndex: undefined };
      }

      // Assuming you want to find the next point that is not just the immediate next index but further away,
      // adjust the minDistanceThreshold as needed.
      let nextPointIndex = this.findFurtherNextPointIndex(nearestPointIndex, routeCoords, 10); // Example threshold

      return { nearestPointIndex, nextPointIndex };
    },


    findFurtherNextPointIndex(nearestPointIndex, routeCoords, minDistanceThreshold = 5) {
      // Ensure nearestPointIndex is within bounds
      if (nearestPointIndex < 0 || nearestPointIndex >= routeCoords.length) {
        console.error("Nearest point index is out of bounds:", nearestPointIndex);
        return undefined;
      }

      // Ensure the nearest point coordinates are valid
      const nearestPointCoords = routeCoords[nearestPointIndex];
      if (!nearestPointCoords || nearestPointCoords.length !== 2) {
        console.error("Invalid nearest point coordinates:", nearestPointCoords);
        return undefined;
      }
      const nearestPoint = turf.point(nearestPointCoords);

      let nextPointIndex = nearestPointIndex + 1;
      let foundFurtherPoint = false;

      while (nextPointIndex < routeCoords.length) {
        const nextPointCoords = routeCoords[nextPointIndex];
        // Ensure the next point coordinates are valid before attempting to create a Turf point
        if (!nextPointCoords || nextPointCoords.length !== 2) {
          console.error("Invalid next point coordinates at index:", nextPointIndex, nextPointCoords);
          nextPointIndex++; // Skip invalid coordinates and try the next set
          continue;
        }

        const nextPoint = turf.point(nextPointCoords);
        const distanceFromNearestPoint = turf.distance(nearestPoint, nextPoint, {units: 'meters'});

        if (distanceFromNearestPoint > minDistanceThreshold) {
          foundFurtherPoint = true;
          break; // Found a point that is sufficiently further away
        }
        nextPointIndex++; // Continue searching further down the route
      }

      return foundFurtherPoint ? nextPointIndex : undefined; // Return undefined if no suitable next point is found
    },


    findNextPointIndexOnRoute(currentIndex) {
      if (currentIndex < this.currentRoute.geometry.coordinates.length - 1) {
        return currentIndex + 1;
      }
      return undefined; // Reached the end of the route
    },

    calculateBearing(startLat, startLng, destLat, destLng) {
      const phi1 = startLat * Math.PI / 180; // Convert startLat to radians
      const phi2 = destLat * Math.PI / 180; // Convert destLat to radians
      const deltaLambda = (destLng - startLng) * Math.PI / 180; // Difference in longitude in radians

      const x = Math.sin(deltaLambda) * Math.cos(phi2);
      const y = Math.cos(phi1) * Math.sin(phi2) -
          Math.sin(phi1) * Math.cos(phi2) * Math.cos(deltaLambda);

      const theta = Math.atan2(x, y);
      const bearing = (theta * 180 / Math.PI + 360) % 360; // Convert to degrees and normalize
      return bearing;
    },


    updateRouteOnMap(route) {
      // Add route data to the map
      if (this.map.getSource('route')) {
        this.map.getSource('route').setData(route.geometry);
      } else {
        this.map.addSource('route', {
          type: 'geojson',
          data: route.geometry,
        });
        this.map.addLayer({
          id: 'route-outer',
          type: 'line',
          source: 'route',
          layout: {},
          paint: {
            'line-width': 10,
            'line-color': 'rgba(0, 0, 0, 0.2)',
          },
        });

        this.map.addLayer({
          id: 'route',
          type: 'line',
          source: 'route',
          layout: {},
          paint: {
            'line-width': 8,
            'line-color': 'rgba(6, 72, 168, 0.6)',
          },
        });
      }
    },

    stopPositionUpdates() {
      if (this.positionUpdateInterval) {
        clearInterval(this.positionUpdateInterval);
        this.positionUpdateInterval = null;
      }
      if (this.watchId) {
        navigator.geolocation.clearWatch(this.watchId);
        this.watchId = null;
      }
    },
    async requestWakeLock() {
      try {
        this.wakeLock = await navigator.wakeLock.request('screen');
        console.log('Wake Lock is active.');
        this.wakeLock.addEventListener('release', () => {
          console.log('Wake Lock was released');
        });
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    },
    openMeterReadingForm(meterId) {
      console.log('Selected Meter ID:', meterId);
      this.selectedMeterId = meterId;
      this.showManualReadingForm = true;
      this.manualReading = null;
      this.readingDate = null;
    },
    /**
     * Submits the manual reading form.
     */
    async submitManualReading() {
      if (!this.selectedMeterId || !this.manualReading) {
        return;
      }

      // Get the route name from the URL params
      const routeName = this.$route.params.routeName;
      const token = localStorage.getItem('access_token');

      if (!token) {
        console.error('No authentication token available');
        return;
      }

      // Prepare the request body according to the new API format
      const requestBody = {
        current_reading: parseFloat(this.manualReading),
        device_id: this.selectedMeterId,
        diagnostic: this.selectedDiagnostics.length > 0 ? this.selectedDiagnostics : [0]
      };

      try {
        const apiBaseUrl = process.env.VUE_APP_API_URL || 'https://metersuite.wtmeters.it/api';
        const response = await axios.post(
            `${apiBaseUrl}/omsroutes/active/route/${routeName}/reading`,
            requestBody,
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': 'application/json'
              }
            }
        );

        if (response.status === 200 && response.data.success) {
          console.log('Reading submitted successfully:', response.data.message);

          if (response.data.route && response.data.route.meter_readings) {
            this.meterReadings = response.data.route.meter_readings;

            // Recalculate counters
            this.nullReadingsCount = 0;
            this.notNullReadingsCount = 0;
            Object.values(this.meterReadings).forEach(m => {
              m.readings?.current_reading !== null ? this.notNullReadingsCount++ : this.nullReadingsCount++;
            });

            this.refreshMarkersAndView();
          }

          // Show success toast
          const bootstrap = await import('../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js');
          const toastEl = document.getElementById('successToast');
          const toastBody = toastEl.querySelector('.toast-body');
          toastBody.textContent = 'Reading submitted successfully.';
          const toast = new bootstrap.Toast(toastEl, {
            autohide: true,
            delay: 3000
          });
          toast.show();

          // Close the form and reset
          this.closeManualReadingForm();

          // Optionally navigate to the next unread meter
          if (this.navigationButton) {
            await this.navigateToNextMeter();
          }
        }
      } catch (error) {
        console.error('Error submitting reading:', error);

        // Show error toast
        const bootstrap = await import('../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js');
        const toastEl = document.getElementById('successToast');
        const toastBody = toastEl.querySelector('.toast-body');
        const toastHeader = toastEl.querySelector('.toast-header strong');
        toastHeader.textContent = 'Error';
        toastBody.textContent = error.response?.data?.message || 'Failed to submit reading. Please try again.';
        const toast = new bootstrap.Toast(toastEl, {
          autohide: true,
          delay: 5000
        });
        toast.show();
      }
    },
    /**
     * Closes the manual reading form.
     */
    closeManualReadingForm() {
      this.showManualReadingForm = false;
    },
    toggleDiagnostic(id) {
      const index = this.selectedDiagnostics.indexOf(id);
      if (index > -1) {
        this.selectedDiagnostics.splice(index, 1);
      } else {
        this.selectedDiagnostics.push(id);
      }
    },

    getMeterStatus(meter) {
      let readings;
      // Check if readings is a string and parse it; if not, use it directly.
      if (typeof meter.readings === 'string') {
        try {
          readings = JSON.parse(meter.readings);
        } catch (error) {
          console.error("Error parsing readings for meter:", meter.meterId, error);
          // Return a default status if parsing fails
          return {
            icon: this.redCircleImage,
            text: 'Error',
          };
        }
      } else {
        readings = meter.readings;
      }

      if (readings.current_reading === null || typeof readings.current_reading === 'undefined') {
        return {
          icon: this.redCircleImage,
          text: 'Unread',
        };
      } else {
        return {
          icon: this.okHandImage,
          text: 'Read',
        };
      }
    },
    beforeRouteLeave(to, from, next) {
      this.allowReconnect = false; // Prevent reconnection attempts
      if (this.websocket) {
        this.websocket.close(); // Close the WebSocket
      }
      next(); // Proceed with the route navigation
    },





  },

  mounted() {
    // Check if geolocation permission has already been granted
    navigator.permissions.query({ name: 'geolocation' }).then(async (result) => {
      if (result.state === 'granted') {
        console.log('Geolocation permission already granted');
        // Prevent the phone from going to sleep
        await this.requestWakeLock();
        // Initialize the map
        this.initializeMap();
      } else {
        // Request geolocation permission
        navigator.geolocation.getCurrentPosition(
            async (position) => {
              console.log('Geolocation permission granted');
              console.log('User location:', position);
              // Prevent the phone from going to sleep
              await this.requestWakeLock();
              // Initialize the map
              this.initializeMap();
            },
            (error) => {
              console.error('Error getting user location:', error);
            }
        );
      }
    });

    document.addEventListener('click', this.handleClickOutside, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
    this.allowReconnect = false;
    if (this.websocket) {
      this.websocket.close();
    }
    this.stopPositionUpdates();

  },




};

</script>
<style scoped>
.marker {
  background-size: cover;
  border-radius: 50%;
  cursor: pointer;
}

.showPanell {
  background: rgba(255, 255, 255, 0.40) !important;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(11.6px) !important;
  -webkit-backdrop-filter: blur(11.6px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  z-index: 1000 !important; /* Ensure it's above other map elements */
  overflow-y: auto !important; /* Enable scrolling for long content */
  -webkit-box-shadow: 0px 0px 22px 10px rgba(0, 0, 0, 0.16) !important;
  transition: transform 1s!important;
}
.showPanell.collapsed {
  transform: translateX(100%);
}

.card {
  border-radius: 16px !important;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(11.6px) !important;
  -webkit-backdrop-filter: blur(11.6px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  background: rgba(255, 255, 255, 0.67) !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(11.6px) !important;
  -webkit-backdrop-filter: blur(11.6px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.box:before {
  content: "";
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(-167deg, #231c34 0%, #57ebde 87%);
  transform: translate3d(-2px, 20px, 0) scale(0.99);
  filter: blur(51px);
  opacity: 0.2;
  transition: opacity 0.3s;
  border-radius: inherit;
}


.box::after {
  content: "";
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: inherit;
  border-radius: inherit;
}

modal-header {
  margin: 20px !important;
}

/* Adjusting the button styles for circular shape */
#my-button-1, #my-button-2, #my-button-3, #next-meter-btn {
  border-radius: 50%; /* Makes the button circular */
  width: 50px; /* Set a fixed width */
  height: 50px; /* Set a fixed height to make it a circle */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0; /* Remove padding to ensure icons/text are centered */
  margin-bottom: 10px; /* Add a margin at the bottom of each button */
}

/* Remove the bottom margin for the last button to avoid extra space */
#my-button-3 {
  margin-bottom: 0;
}

/* Positioning buttons at the right center of the screen */
.buttons-container {
  position: fixed;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2000;
}



.readings-container{
  background: rgba(14, 79, 36, 0.8);
  border-radius: 10px;
  padding: 10px;
  color: #000;
}

.directions-container {
  border-radius: 10px;
  padding: 10px;
  color: #1A1D1F;
}

.directions-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  z-index: 1000;
  border-radius: 10px;
  padding: 10px;
  margin: 20px;
  width: calc(100% - 40px);
  color: #ffffff;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.02), 0 0 20px rgba(0, 0, 0, 0.05);
  background: rgba(0, 0, 0, 0.6) !important;
}

/* Liquid Glass Effect Elements */
.directions-container .liquidGlass-effect,
.directions-container .liquidGlass-tint,
.directions-container .liquidGlass-shine {
  position: absolute;
  inset: 0;
  opacity: 1;
  pointer-events: none;
}

.directions-container .liquidGlass-effect {
  z-index: 0;
  backdrop-filter: blur(11.6px);
  -webkit-backdrop-filter: blur(11.6px);
  filter: url(#glass-distortion);
  isolation: isolate;

}

.directions-container .liquidGlass-tint {
  z-index: 1;
  background: rgba(255, 255, 255, 0.04);
}

.directions-container .liquidGlass-shine {
  z-index: 2;
}

/* Content must be above the glass effect */
.directions-content {
  position: relative;
  z-index: 3;
  width: 100%;
}


/* Content must be above the glass effect */
.directions-content {
  position: relative;
  z-index: 3;
  width: 100%;
}


.speed-container {
  position: absolute;
  bottom: 60px;
  left: 20px;
  background: rgba(0, 0, 0, 0.60) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(11.6px) !important;
  -webkit-backdrop-filter: blur(11.6px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  overflow-y: auto !important; /* Enable scrolling for long content */
  -webkit-box-shadow: 0px 0px 22px 10px rgba(0, 0, 0, 0.16) !important;
  z-index: 1000;
  border-radius: 10px;
  padding: 10px;
  color: #fff;
}




.readings-container {
  position: fixed; /* Use fixed instead of absolute for viewport-relative positioning */
  bottom: 60px;
  right: 20px;
  background: rgba(0, 0, 0, 0.60) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(11.6px) !important;
  -webkit-backdrop-filter: blur(11.6px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  overflow-y: auto !important; /* Enable scrolling for long content */
  -webkit-box-shadow: 0px 0px 22px 10px rgba(0, 0, 0, 0.16) !important;
  padding: 10px;
  color: #ffffff;
  z-index: 1000; /* Ensure it's above most other content */
}

/* Adjustments for iPhones */
@media only screen and (max-width: 812px) { /* Covers iPhone X/XS/11 Pro and similar */
  .speed-container,
  .readings-container {
    bottom: 100px; /* Increase bottom spacing */
  }
}

/* Additional considerations for iPads */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .speed-container,
  .readings-container {
    bottom: 100px; /* Adjust for iPad screen sizes */
  }
}

.animate-row {
  opacity: 0;
  transform: translateY(-20px);
  animation: slideIn 0.3s forwards;
  animation-delay: var(--delay);
}

@keyframes slideIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.icon {
  width: 30px;
  height: 30px;
}
.icon-sm-yes{
  background-color: #4fbd20;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 1px solid #fff;
  opacity: 0.8;
}
.icon-sm-no{
  background-color: #fcba03;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 1px solid #fff;
  opacity: 0.8;
}


.btn {
  background: rgba(0, 0, 0, 0.60) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(11.6px) !important;
  -webkit-backdrop-filter: blur(11.6px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  overflow-y: auto !important; /* Though this property is unusual for buttons */
  -webkit-box-shadow: 0px 0px 22px 10px rgba(0, 0, 0, 0.16) !important;
  z-index: 1000;
  color: #fff; /* Assuming you want white text */
  padding: 8px 16px; /* Example padding, adjust as needed */
  border-radius: 8px; /* Example border-radius, adjust as needed */
}
.btn:hover, .btn:active {
  background: rgba(0, 0, 0, 0.80) !important;
}

.btn.active {
  background: rgba(0, 0, 0, 1) !important;
}
input[type=checkbox] {
  height: 0;
  width: 0;
  visibility: hidden;
}

label {
  cursor: pointer;
  text-indent: -9999px;
  width: 100px;
  height: 50px;
  background: rgba(0, 0, 0, 0.60) !important;

  display: block;
  border-radius: 50px;
  position: relative;
  z-index: 1;
}

label::after {
  content: '';
  position: absolute;
  top: 5px;
  left: 5px;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 40px;
  transition: 0.3s;
  z-index: 2;
}

.nav-text,
.map-text {

  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
  font-size: 14px;
  z-index: 3;
  transform-origin: center center;
  pointer-events: none;
}

.nav-text {
  left: 10px;
  top: 45px;
  color: #171717;
  font-weight: bold;
}

.map-text {
  top: 45px;
  right: 10px;
  color: white;
}

input:checked + label {
  background: rgba(0, 0, 0, 0.60) !important;

}

input:checked + label::after {
  left: calc(100% - 45px);
}

input:checked + label + .nav-text {
  color: white;
}

input:checked + label + .nav-text + .map-text {
  color: #171717;
  font-weight: bold;
}

label:active::after {
  width: 60px;
}

/* Next Meter Button Container - Right Side */
.next-meter-container {
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2000;
}
.gateway-status-container {
  position: fixed;
  top: 200px;
  left: 45px;
  z-index: 1000;
  background: rgba(55, 71, 79, 0.9);
  padding: 12px;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
}

.gateway-status-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
}

.gateway-status-circle.online {
  background-color: #4fbd20; /* Green - matches your "to read" indicator */
  box-shadow: 0 0 0 3px rgba(79, 189, 32, 0.3),
  0 0 15px rgba(79, 189, 32, 0.5);
  animation: pulse-green 2s infinite;
}

.gateway-status-circle.offline {
  background-color: #ef4444; /* Red */
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3),
  0 0 15px rgba(239, 68, 68, 0.5);
  animation: pulse-red 2s infinite;
}

@keyframes pulse-green {
  0%, 100% {
    box-shadow: 0 0 0 3px rgba(79, 189, 32, 0.3),
    0 0 15px rgba(79, 189, 32, 0.5);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(79, 189, 32, 0.2),
    0 0 20px rgba(79, 189, 32, 0.7);
  }
}

@keyframes pulse-red {
  0%, 100% {
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3),
    0 0 15px rgba(239, 68, 68, 0.5);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(239, 68, 68, 0.2),
    0 0 20px rgba(239, 68, 68, 0.7);
  }
}

</style>